import * as React from 'react';
import { TextField, Box } from '@mui/material';
import { CountryPhonePrefixField } from './CountryPhonePrefixField';

export interface PhoneNumberFieldProps {
    value?: string;
    prefix?: string;
    id?: string;
    label?: string;
    placeholder?: string;
    disabled?: boolean;
    variant?: 'standard' | 'outlined' | 'filled' | 'nobox';
    onChange: (value: string, prefix: string) => void;
}

export const PhoneNumberField = (props: PhoneNumberFieldProps) => {
    const {
        value = '',
        prefix = '+351',
        id,
        label,
        placeholder,
        disabled,
        variant = 'outlined',
        onChange,
    } = props;

    return (
        <Box style={{ display: 'flex', gap: '8px' }}>
            <CountryPhonePrefixField
                id={id ? `${id}-prefix` : undefined}
                value={prefix}
                disabled={disabled}
                variant={variant}
                onChange={newPrefix => onChange(value, newPrefix)}
            />
            <TextField
                id={id ? `${id}-input` : undefined}
                type="tel"
                label={label}
                placeholder={placeholder}
                disabled={disabled}
                value={value}
                onChange={e => onChange(e.target.value.replace(/\s/g, ''), prefix)}
                style={{ flex: 1, minWidth: 0 }}
                sx={variant === 'nobox' ? {
                    "& .MuiInput-underline:before": { borderBottom: "none" },
                } : undefined}
                variant={variant === 'nobox' ? 'standard' : variant}
                size="small"
                fullWidth
            />
        </Box>
    );
}
